// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Haggle — the one door between what is known and what is hidden.
//
// This module is deliberately tiny and deliberately its own file, because that is what makes the
// rule enforceable: `src/bot.ts` may not import it, and `tests/sight.test.ts` fails the build if the
// literals `secret`, `.crate[` or `.satchels[` appear in the bot's source at all. A discipline you
// can grep for is worth more than a discipline you can only intend.
//
// `viewFor` DEEP-COPIES. A live reference into the real state reads the future and no type system
// catches it — the aliasing test in sight.test.ts mutates the FullState after taking a view and
// asserts the view did not move.

import { clonePublic, type FullState, type Seat, type SeatView } from './rules';

export function viewFor(fs: FullState, seat: Seat): SeatView {
  return { pub: clonePublic(fs.pub), seat, satchel: [...fs.sec.satchels[seat]] };
}

/**
 * The cards nobody has accounted for from `seat`'s chair: the whole deck, minus everything on the
 * table, minus everything either player has already spent in public, minus its own satchel. This is
 * the belief the bot samples its determinisations from, and it is computed from PUBLIC information
 * plus the seat's own hand — never from `Secret`.
 */
export type { SeatView };
